import { Stack, Typography } from '@mui/material';
import { HelpFooter } from '@/packages/courses/pages/registration/components/help-footer';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';

interface DefaultSuccessDialogProps {
  onClose: () => void;
  institutionName?: string;
  email?: string;
  phone?: string;
}

const buildChannelsText = (email?: string, phone?: string) => {
  const channels = [
    email && `seu e-mail (${email})`,
    phone && `WhatsApp ${phone}`,
  ].filter(Boolean);

  if (channels.length === 0) return null;

  return `pelo ${channels.join(' ou ')}`;
};

export const DefaultSuccessDialog = ({
  onClose,
  institutionName,
  email,
  phone,
}: DefaultSuccessDialogProps) => {
  const channelsText = buildChannelsText(email, phone);

  return (
    <BaseDialog
      open
      onClose={onClose}
      icon={<Icon name="success" size={54} alt="Sucesso" />}
      title="Inscrição realizada com sucesso!"
    >
      <Stack spacing={3}>
        <Stack spacing={2}>
          <Typography>
            Sua inscrição foi encaminhada para a instituição {institutionName}.
          </Typography>
          <Typography fontWeight="semibold">
            Você receberá as orientações para concluir sua matrícula{' '}
            {channelsText && `${channelsText}, `}conforme o processo da
            instituição parceira.
          </Typography>
          <Typography>
            Verifique também sua caixa de spam ou lixo eletrônico
          </Typography>
        </Stack>
        <HelpFooter />
      </Stack>
    </BaseDialog>
  );
};
